// state
export const UPDATE_LOADING = 'UPDATE_LOADING'
export const SHOW_TOAST = 'SHOW_TOAST'

// user
export const FETCH_USER_INFO = 'FETCH_USER_INFO'
export const FETCH_USER_FAVOUR = 'FETCH_USER_FAVOUR'
export const REGISTER_USER = 'REGISTER_USER'
export const UPDATE_USER = 'UPDATE_USER'

// league
export const FETCH_LEAGUE_LIST = 'FETCH_LEAGUE_LIST'
export const FETCH_FILTER_INFO = 'FETCH_FILTER_INFO'

// match
export const FETCH_MATCH_LIST = 'FETCH_MATCH_LIST'
export const FETCH_RECOMMEND_MATCH_LIST = 'FETCH_RECOMMEND_MATCH_LIST'

export const FETCH_MATCH_INTRODUCTION = 'FETCH_MATCH_INTRODUCTION'
export const FETCH_MATCH_DETAIL = 'FETCH_MATCH_DETAIL'

export const FETCH_SEARCH_RESULT = 'FETCH_SEARCH_RESULT'
export const TOGGLE_MATCH_FAVOUR = 'TOGGLE_MATCH_FAVOUR'

// order
export const FETCH_ORDER_LIST = 'FETCH_ORDER_LIST'
export const FETCH_ORDER = 'FETCH_ORDER'
export const SAVE_ORDER_DATA = 'SAVE_ORDER_DATA'
export const SAVE_CUSTOM_ORDER_DATA = 'SAVE_CUSTOM_ORDER_DATA'

// adv
export const FETCH_ADV = 'FETCH_ADV'

// route
export const FETCH_ROUTE_LIST = 'FETCH_ROUTE_LIST'
export const FETCH_ROUTE_DETAIL = 'FETCH_ROUTE_DETAIL'
export const FETCH_ROUTE_CATEGORY = 'FETCH_ROUTE_CATEGORY'
export const FETCH_ROUTE_FILTER = 'FETCH_ROUTE_FILTER'
export const FETCH_RECOMMEND_ROUTE_LIST = 'FETCH_RECOMMEND_ROUTE_LIST'
export const TOGGLE_ROUTE_FAVOUR = 'TOGGLE_ROUTE_FAVOUR'

// question
export const FETCH_QUESTION_LIST = 'FETCH_QUESTION_LIST'
export const ADD_QUESTION = 'ADD_QUESTION'

// raiders
export const FETCH_RAIDERS = 'FETCH_RAIDERS'

// custom 定制旅行mutation
export const FETCH_CUSTOM_FILTER_INFO = 'FETCH_CUSTOM_FILTER_INFO'
export const FETCH_CUSTOM_ROUTE_CATEGORY_LIST = 'FETCH_CUSTOM_ROUTE_CATEGORY_LIST'
export const FETCH_CUSTOM_ROUTE_LIST = 'FETCH_CUSTOM_ROUTE_LIST'
export const FETCH_CUSTOM_ORDER_SERVICES = 'FETCH_CUSTOM_ORDER_SERVICES'
export const FETCH_CUSTOM_ROUTE_BY_ID = 'FETCH_CUSTOM_ROUTE_BY_ID'
export const FETCH_SPORTS_RAIDERS_LIST = 'FETCH_SPORTS_RAIDERS_LIST'
export const FETCH_CUSTOM_ORDER_INTRO = 'FETCH_CUSTOM_ORDER_INTRO'
export const FETCH_CUSTOM_ORDER = 'FETCH_CUSTOM_ORDER'
export const FETCH_RECOMMEND_CUSTOM_LIST = 'FETCH_RECOMMEND_CUSTOM_LIST'

// attn 我的 常用信息
export const FETCH_USER_ATTN_BY_USERID = 'FETCH_USER_ATTN_BY_USERID'
export const FETCH_USER_ADDRESS_BY_USERID = 'FETCH_USER_ADDRESS_BY_USERID'
export const FETCH_USER_REAL_NAME_BY_USERID = 'FETCH_USER_REAL_NAME_BY_USERID'
export const FETCH_USER_COMMON_ATTN_BY_USERID = 'FETCH_USER_COMMON_ATTN_BY_USERID'

// worldCup match
export const FETCH_WORLD_CUP_MATCH_LIST = 'FETCH_WORLD_CUP_MATCH_LIST'
export const FETCH_TOUR_DETAIL = 'FETCH_TOUR_DETAIL'
export const SAVE_TOUR_ORDER_DATA = 'SAVE_TOUR_ORDER_DATA'

// C2C
export const FETCH_CTC_SELLING_ORDER_BY_USERID = 'FETCH_CTC_SELLING_ORDER_BY_USERID'  // 转票列表
export const FETCH_CTC_SOLD_ORDER_BY_USERID = 'FETCH_CTC_SOLD_ORDER_BY_USERID'        // 已转列表
export const FETCH_CTC_BUYER_ORDER = 'FETCH_CTC_BUYER_ORDER'                          // C2C买家订单
export const FETCH_CTC_SELLER_ORDER = 'FETCH_CTC_SELLER_ORDER'                        // C2C卖家订单
export const SAVE_CTC_BUY_ORDER_DATA = 'SAVE_CTC_BUY_ORDER_DATA'

// Wallet
export const SAVE_WALLET_PAY_PASSWORD = 'SAVE_WALLET_PAY_PASSWORD'
export const SAVE_BINDING_BANK_CARD = 'SAVE_BINDING_BANK_CARD'
export const SAVE_IS_PAY_PWD = 'SAVE_IS_PAY_PWD'
export const SAVE_DRAW_CASH_BANK_CARD = 'SAVE_DRAW_CASH_BANK_CARD'

// SportsTour
export const FETCH_SPORTS_TOUR_ROUTE_LIST = 'FETCH_SPORTS_TOUR_ROUTE_LIST'
export const FETCH_SPORTS_TOUR_FILTER_INFO = 'FETCH_SPORTS_TOUR_FILTER_INFO'
export const FETCH_SPORTS_TOUR_ROUTE_BY_ID = 'FETCH_SPORTS_TOUR_ROUTE_BY_ID'
export const FETCH_TRAVEL_ORDER_LIST = 'FETCH_TRAVEL_ORDER_LIST'



// WEBPACK FOOTER //
// ./client/vuex/mutation-types.js